<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

import Spinner from '../Spinner.svelte';
import DataTable from '../DataGrid/DataTable.svelte';
import { sgettext } from '../../i18n.js';
import { onMount } from 'svelte';
import { get } from '../../utils.js';
import { relatedActivitiesList } from '../GlobalHazard/store.js';
import RelatedActivityName from './RelatedActivityName.svelte';
import RelatedActivityStatus from './RelatedActivityStatus.svelte';
import RelatedActivityType from './RelatedActivityType.svelte';

export let branchHazardControlId;

let currentPage = 1;
let rows = [];
let total = 0;
let loading = true;
let perPage = 10;

let dataUrl = `${PATH_PREFIX}/sw/api/bhc-usage-in-activities/${branchHazardControlId}`;

let columns = {
    name: {
        label: sgettext('$$NAME$$'),
        renderer: RelatedActivityName,
        width:'50%'
    },
    template_status: {
        label: sgettext('$$STATUS$$'),
        renderer: RelatedActivityStatus,
        width:'20%'
    },
    num_instances: {
        label: sgettext('$$INSTANCES_1$$'),
        width:'20%'
    },
};

onMount(async () => {
   await fetchResults();
});

async function fetchResults() {
    var url = `${dataUrl}/?limit=${perPage}&offset=${(currentPage - 1)*perPage}&page=${currentPage}`;
    const resp = await get(url);
    const re = await resp.json();
    try {
        total = re.count;
        relatedActivitiesList.set(re.results);
        loading = false;
    } catch (err) {
        console.error(err);
        total = 0;
        relatedActivitiesList.set([]);
    } finally {
        loading = false;
    } 
 }

 function changePage(params) {
    currentPage = params.page;
    fetchResults();
}

</script>

<style>
    .spinnerDiv{
        height:140px;;
        padding-top: 40px;
        padding-left :190px;
    }
    .detail{
        cursor: pointer;
    }
</style>

<section class="related-activities">
    <header>
    <h6>{sgettext('$$RELATED_ACTIVITIES$$')}</h6>
    </header>
    <div class="detail">
        {#if loading}
            <div class="spinnerDiv">
                <i class="fas fa-spinner fa-pulse"></i>
            </div>
        {:else}
            <DataTable
                {columns}
                small={true}
                hover={true}
                rows={$relatedActivitiesList}
                emptyLabel={sgettext('$$RESULTS_FOUND_1$$')}
                showFooter={total > perPage}
                total={total}
                perPage={perPage}
                currentPage={currentPage}
                changePage={changePage}
                footerColSpan={7}
            />
        {/if}
    </div>
</section>